import { useState, useEffect } from "react";
import Info from "../assets/icons/ic_info.svg";
import { packageOptionDetials } from "api/apiService";
import { getAccommodationDetials } from "api/apiService";
import {
  BASE_DISABLE_RULES,
  shiftDisableRules,
} from "../components/userForms/constants";

export default function TourPackageOptions({
  showPopup,
  formData,
  formErrors,
  onOptionChange,
  setFormErrors,
  allParticipantsData,
  isInvited,
}) {
  const [tripName, setTripName] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [packageOption, setPackageOption] = useState([]);
  const TOUR_OPTIONS = packageOption;
  const userType = localStorage.getItem("userType");
  const parentName = localStorage.getItem("parentName");
  const parentEmail = localStorage.getItem("parentEmail");
  const isReadOnly = userType === "yes" || isInvited === "yes";

  useEffect(() => {
    const trip = sessionStorage.getItem("tripName");
    setTripName(trip);
  }, []);

  useEffect(() => {
    const fetchPackageOption = async () => {
      try {
        const response = await packageOptionDetials(tripName);
        setPackageOption(response);
      } catch (err) {
        console.error("Failed to fetch package details", err);
      }
    };

    if (tripName) fetchPackageOption();
  }, [tripName]);

  // Sync initial options from formData
  useEffect(() => {
    if (Array.isArray(formData.tourOptions)) {
      setSelectedOptions(formData.tourOptions);
    }
  }, [formData.tourOptions]);

  useEffect(() => {
    if (selectedOptions.length > 0 && formErrors?.tourOptions) {
      setFormErrors((prev) => ({ ...prev, tourOptions: "" }));
    }
  });

  const handleCheckboxChange = (option, isChecked) => {
    const minimalOption = {
      packageOptionId: option.packageId,
      packageOption: option.packageOption,
      price: option.price,
      country: option.country, // include country
      currency: option.currency,
    };

    let updatedOptions = [...selectedOptions];

    if (isChecked) {
      // Add the selected option if it's not already selected
      if (
        !updatedOptions.some((opt) => opt.packageOptionId === option.packageId)
      ) {
        updatedOptions.push(minimalOption);
      }
    } else {
      // eslint-disable-next-line no-undef
      const startIndex = packageOption[0].packageId;
      const DISABLE_RULES = shiftDisableRules(BASE_DISABLE_RULES, startIndex);

      const hasDisableRule = Object.prototype.hasOwnProperty.call(
        DISABLE_RULES,
        option.packageId
      );

      if (hasDisableRule) {
        // Option has disable rules → clear all
        updatedOptions = [];
      } else {
        // Otherwise, remove only the unchecked option
        updatedOptions = updatedOptions.filter(
          (selected) => selected.packageOptionId !== option.packageId
        );
      }
    }

    setSelectedOptions(updatedOptions);
    onOptionChange?.(updatedOptions);
  };
  const getDisabledIds = () => {
    const startIndex =
      packageOption.length > 0 ? packageOption?.[0].packageId : 1;
    const DISABLE_RULES = shiftDisableRules(BASE_DISABLE_RULES, startIndex);
    const disabledSet = new Set();

    selectedOptions.forEach((selected) => {
      const id = selected.packageOptionId;

      if (
        id != null &&
        Object.prototype.hasOwnProperty.call(DISABLE_RULES, id)
      ) {
        DISABLE_RULES[id].forEach((disabledId) => disabledSet.add(disabledId));
      }
    });

    return disabledSet;
  };

  // const calculateTotal = () => {
  //   const baseTotal = selectedOptions.reduce(
  //     (acc, curr) => acc + curr.price,
  //     0
  //   );
  //   return allParticipantsData.length > 0
  //     ? baseTotal * (allParticipantsData.length + 1)
  //     : (formData.participantExists === "yes" &&
  //         formData.participantCount === 0) ||
  //       formData.isInvited === "yes" ||
  //       formData.userType === "yes"
  //     ? baseTotal * 2
  //     : baseTotal;
  // };
  //  As senthil said this was changed

  const calculateTotal = () => {
    const baseTotal = selectedOptions.reduce((acc, curr) => {
      const numericPrice = parseFloat(
        String(curr.price)
          .replace(/[,.](?=\d{3}\b)/g, "")
          .replace(",", ".")
      );
      return acc + (isNaN(numericPrice) ? 0 : numericPrice);
    }, 0);

    return allParticipantsData.length > 0
      ? baseTotal * (allParticipantsData.length + 1)
      : (formData.participantExists === "yes" &&
          formData.participantCount === 0) ||
        formData.isInvited === "yes" ||
        formData.userType === "yes"
      ? baseTotal * 2
      : baseTotal;
  };

  const disabledIds = getDisabledIds();

  useEffect(() => {
    const fetchAccommodationDetails = async () => {
      try {
        const res = await getAccommodationDetials(
          parentName,
          parentEmail,
          tripName
        );
        const selectedFromAPI = res?.tourPackageOptionDTOS || [];
        const minimalOptions = selectedFromAPI.map((opt) => ({
          packageOptionId: opt.packageOptionId,
          packageOption: opt.packageOption,
          price: opt.price,
          country: opt.country,
          currency: opt.currency,
        }));
        setSelectedOptions(minimalOptions);
        onOptionChange?.(minimalOptions);
      } catch (error) {
        console.error("Error fetching accommodation details", error);
      }
    };

    if (tripName && parentName && parentEmail) fetchAccommodationDetails();
  }, [tripName]);

  const usaOptions = TOUR_OPTIONS.filter((opt) => opt.country === "USA");
  const euroOptions = TOUR_OPTIONS.filter((opt) => opt.country === "EURO");

  return (
    <div className="px-4 sm:px-10 py-4">
      <h2 className="text-xl font-semibold">Tour Price</h2>
      {tripName.includes("greece") && (
        <p className="text-sm text-yellow-800">
          (For Double occupancy with an invited traveler, the price shown is for
          one person. Once your invited traveler is registered, the amount will
          be doubled based on the current price you selected.)
        </p>
      )}
      <p
        className={`text-sm text-gray-600 mb-4 ${
          tripName.includes("greece") ? "pt-2" : ""
        }`}
      >
        {tripName.includes("europe")
          ? "Make your travel choices below (required). All funds are denominated in US$"
          : "Make your travel choices below (required). All funds are denominated in US$ and Europe€."}
      </p>

      <div className="mb-4">
        <p className="font-medium mb-2">Make a choice here:</p>

        {usaOptions.length !== 0 && (
          <div className="mb-6">
            <h6 className="font-medium underline mb-2">
              {tripName && tripName.includes("europe")
                ? "European Youth Congress 2026 & Reformation Tour (USA & Non-European passport holders)"
                : "USA & non-European passport holders"}
            </h6>
            {usaOptions.map((option, index) => {
              const isDisabled =
                disabledIds.has(option.packageId) &&
                !selectedOptions.some(
                  (selected) => selected.packageOptionId === option.packageId
                );

              const isChecked = selectedOptions.some(
                (e) => e.packageOptionId === option.packageId
              );

              // custom spacing logic
              let extraClass = "";
              if (index === 1) extraClass = "pb-6"; // after 2nd item
              if (index === 5) extraClass = "pb-6"; // after 6th item

              return (
                <div
                  key={option.packageId}
                  className={`flex items-center gap-2 mb-2 ${extraClass}`}
                >
                  <input
                    type="checkbox"
                    name="tourOptions"
                    checked={isChecked}
                    onChange={(e) => {
                      handleCheckboxChange(option, e.target.checked);
                    }}
                    className="w-4 h-4 text-primary border-gray-300"
                    disabled={
                      isDisabled ||
                      isReadOnly ||
                      (formData.tourOptions?.length >= 0 &&
                        showPopup &&
                        formData.userType === "yes")
                    }
                  />
                  <span
                    className={`text-sm ${
                      isDisabled ? "text-gray-400 cursor-not-allowed" : ""
                    }`}
                  >
                    {option.packageOption} – {option.currency}
                    {option.price} / person
                  </span>
                </div>
              );
            })}
          </div>
        )}

        {euroOptions.length !== 0 && (
          <div className="mb-6">
            <h6 className="font-medium underline mb-2">
              European passport holders
            </h6>
            {euroOptions.map((option, index) => {
              const isDisabled =
                disabledIds.has(option.packageId) &&
                !selectedOptions.some(
                  (selected) => selected.packageOptionId === option.packageId
                );

              const isChecked = selectedOptions.some(
                (e) => e.packageOptionId === option.packageId
              );

              // custom spacing logic
              let extraClass = "";
              if (index === 3) extraClass = "pb-6"; // after 2nd item
              if (index === 7) extraClass = "pb-6"; // after 6th item

              return (
                <div
                  key={option.packageId}
                  className={`flex items-center gap-2 mb-2 ${extraClass}`}
                >
                  <input
                    type="checkbox"
                    name="tourOptions"
                    checked={isChecked}
                    onChange={(e) => {
                      handleCheckboxChange(option, e.target.checked);
                    }}
                    className="w-4 h-4 text-primary border-gray-300"
                    disabled={
                      isDisabled ||
                      isReadOnly ||
                      (formData.tourOptions?.length >= 0 &&
                        showPopup &&
                        formData.userType === "yes")
                    }
                  />
                  <span
                    className={`text-sm ${
                      isDisabled ? "text-gray-400 cursor-not-allowed" : ""
                    }`}
                  >
                    {option.packageOption} – {option.currency}
                    {/* As senthil said this was changed */}
                    {/* {option.price.toLocaleString("de-DE")} / person */}
                    {option.price} / person
                  </span>
                </div>
              );
            })}
          </div>
        )}

        {formErrors?.tourOptions && (
          <div className="flex gap-1 w-fit text-[10px] bg-red-100 text-red-600 mt-1 rounded p-[3px]">
            <img src={Info} alt="info" />
            {formErrors?.tourOptions}
          </div>
        )}
      </div>

      <div className="text-right font-medium text-lg">
        Total:{" "}
        {selectedOptions.some((opt) => opt.country === "EURO")
          ? `€${calculateTotal().toLocaleString("de-DE")}`
          : `$${calculateTotal().toLocaleString("en-US")}`}
      </div>
    </div>
  );
}
